module.exports = __webpack_public_path__ + "media/images/country_flags/bh-15d323483c73e57b48b2ac781b0551f5.png";